var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "nav",
        {
          staticClass: "navbar nav-bar-class",
          class: { displayNav: !_vm.displaySide, disable: !_vm.$parent.online },
        },
        [
          _c("div", [
            _c("aside", [
              _c("section", [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-3 col-md-3 sidebar-content" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sidebar-col",
                          class: {
                            displaySide: _vm.displaySide,
                            "theme-admin":
                              _vm.roleId && [5, 7, 11].includes(_vm.roleId),
                          },
                        },
                        [
                          _vm.roleId
                            ? _c(
                                "ul",
                                {
                                  staticStyle: { "margin-top": "1px" },
                                  attrs: { id: "accordion" },
                                },
                                [
                                  ![4, 10, 12, 13, 14, 15].includes(_vm.roleId)
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "menu_item active-icon icon-dashboard",
                                          class: {
                                            active:
                                              _vm.activeMenu.indexOf(
                                                "layout/dashboard"
                                              ) != -1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.redirect("/layout/dashboard")
                                              _vm.emitEvent()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "content" },
                                                [
                                                  _vm._v("Dashboard "),
                                                  _vm.isDashboardCustomizable
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa fa-pencil-square-o edit-icon",
                                                        attrs: {
                                                          "aria-hidden": "true",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.emitEventOpenEditDashboard.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  ![4, 10, 12, 13, 14, 15].includes(_vm.roleId)
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "menu_item active-icon icon-marketplace",
                                          class: {
                                            active:
                                              _vm.activeMenu.indexOf(
                                                "layout/market-place"
                                              ) != -1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.redirect(
                                                "/layout/market-place"
                                              )
                                              _vm.emitEvent()
                                            },
                                          },
                                        },
                                        [_vm._m(0)]
                                      )
                                    : _vm._e(),
                                  ![4, 10, 12, 13, 14, 15].includes(_vm.roleId)
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "menu_item active-icon icon-notification",
                                          class: {
                                            active:
                                              _vm.activeMenu.indexOf(
                                                "layout/alert"
                                              ) != -1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.showAlertPage("/layout/alert")
                                              _vm.emitEvent()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                            },
                                            [
                                              _vm.newNotificationCountFlag
                                                ? _c("span", {
                                                    class: [
                                                      {
                                                        "bell-highlight":
                                                          _vm.newNotificationCountFlag,
                                                      },
                                                      [5, 7, 11].includes(
                                                        _vm.roleId
                                                      )
                                                        ? "border-color-admin"
                                                        : "border-color-user",
                                                    ],
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "span",
                                                { staticClass: "content" },
                                                [_vm._v("Notifications")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  ![3, 4, 6, 7, 10, 12, 13, 14, 15].includes(
                                    _vm.roleId
                                  )
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "menu_item active-icon icon-smartdocs",
                                          class: {
                                            active:
                                              _vm.activeMenu.indexOf(
                                                "layout/smart-docs"
                                              ) != -1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.redirect("/layout/smart-docs")
                                              _vm.emitEvent()
                                            },
                                          },
                                        },
                                        [_vm._m(1)]
                                      )
                                    : _vm._e(),
                                  _vm.roleId !== 4
                                    ? _c(
                                        "div",
                                        { staticClass: "panel custom-panel" },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "main-content menu_item active-icon icon-resources",
                                              class: {
                                                active:
                                                  ![
                                                    10, 12, 13, 14, 15,
                                                  ].includes(_vm.roleId) &&
                                                  _vm.activeMenu.indexOf(
                                                    "layout/resourcesdashboard"
                                                  ) != -1,
                                              },
                                              attrs: {
                                                "data-toggle": "collapse",
                                                "data-parent": "#accordion",
                                                href: "#collapseOne",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  ![
                                                    10, 12, 13, 14, 15,
                                                  ].includes(_vm.roleId)
                                                    ? _vm.redirect(
                                                        "/layout/resourcesdashboard"
                                                      )
                                                    : ""
                                                },
                                              },
                                            },
                                            [_vm._m(2)]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "panel-collapse collapse",
                                              attrs: { id: "collapseOne" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "panel-body" },
                                                [
                                                  _c(
                                                    "ul",
                                                    { staticClass: "sub_menu" },
                                                    [
                                                      _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "menu_item active-icon",
                                                          class: {
                                                            active:
                                                              _vm.activeMenu.indexOf(
                                                                "layout/regsandguidance"
                                                              ) != -1,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.redirect(
                                                                "/layout/regsandguidance"
                                                              )
                                                              _vm.emitEvent()
                                                            },
                                                          },
                                                        },
                                                        [_vm._m(3)]
                                                      ),
                                                      _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "menu_item active-icon",
                                                          class: {
                                                            active:
                                                              _vm.activeMenu.indexOf(
                                                                "layout/tools"
                                                              ) != -1,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.redirect(
                                                                "/layout/tools"
                                                              )
                                                              _vm.emitEvent()
                                                            },
                                                          },
                                                        },
                                                        [_vm._m(4)]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.roleId !== 4 &&
                                  ([5, 7].includes(_vm.roleId) ||
                                    _vm.account_type_id === 2)
                                    ? _c(
                                        "div",
                                        { staticClass: "panel custom-panel" },
                                        [
                                          _vm._m(5),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "panel-collapse collapse",
                                              attrs: {
                                                id: "collapseRepResources",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "panel-body" },
                                                [
                                                  _c(
                                                    "ul",
                                                    { staticClass: "sub_menu" },
                                                    [
                                                      _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "menu_item active-icon",
                                                          class: {
                                                            active:
                                                              _vm.activeMenu.indexOf(
                                                                "layout/representationresources/producttracker"
                                                              ) != -1,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.redirect(
                                                                "/layout/representationresources/producttracker"
                                                              )
                                                              _vm.emitEvent()
                                                            },
                                                          },
                                                        },
                                                        [_vm._m(6)]
                                                      ),
                                                      _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "menu_item active-icon",
                                                          class: {
                                                            active:
                                                              _vm.activeMenu.indexOf(
                                                                "layout/representationresources/guidesandtemplates"
                                                              ) != -1,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.redirect(
                                                                "/layout/representationresources/guidesandtemplates"
                                                              )
                                                              _vm.emitEvent()
                                                            },
                                                          },
                                                        },
                                                        [_vm._m(7)]
                                                      ),
                                                      _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "menu_item active-icon",
                                                          class: {
                                                            active:
                                                              _vm.activeMenu.indexOf(
                                                                "/layout/representationresources/agreements"
                                                              ) !== -1,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.redirect(
                                                                "/layout/representationresources/agreements"
                                                              )
                                                              _vm.emitEvent()
                                                            },
                                                          },
                                                        },
                                                        [_vm._m(8)]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  ![4, 6, 14].includes(_vm.roleId)
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "menu_item active-icon icon-smartexchange",
                                          class: {
                                            active:
                                              _vm.activeMenu.indexOf(
                                                "layout/smart-exchange"
                                              ) != -1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.redirect(
                                                "/layout/smart-exchange"
                                              )
                                              _vm.emitEvent()
                                            },
                                          },
                                        },
                                        [_vm._m(9)]
                                      )
                                    : _vm._e(),
                                  ![4, 10, 15].includes(_vm.roleId)
                                    ? [
                                        _vm._m(10),
                                        _vm._l(
                                          _vm.premiumServices,
                                          function (service, index) {
                                            return [
                                              ![12, 13, 14, 15].includes(
                                                _vm.roleId
                                              ) ||
                                              ([12, 13, 15].includes(
                                                _vm.roleId
                                              ) &&
                                                service.name ===
                                                  "Registration Tracker") ||
                                              (_vm.roleId === 14 &&
                                                (service.name ===
                                                  "Registration Tracker" ||
                                                  service.name ===
                                                    "Regulatory Intelligence"))
                                                ? [
                                                    !service.dropdown
                                                      ? _c(
                                                          "li",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "menu_item active-icon",
                                                            class: [
                                                              {
                                                                active:
                                                                  _vm.activeMenu.indexOf(
                                                                    service.shortPath
                                                                  ) != -1,
                                                              },
                                                              service.icon,
                                                            ],
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.redirect(
                                                                  service.path
                                                                )
                                                                _vm.emitEvent()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("a", [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "content wrap-content",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      service.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    service.dropdown
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "panel custom-panel",
                                                            },
                                                            [
                                                              _c(
                                                                "li",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "main-content menu_item",
                                                                  class: [
                                                                    {
                                                                      active:
                                                                        _vm.activeMenu.indexOf(
                                                                          service.shortPath
                                                                        ) != -1,
                                                                    },
                                                                    service.icon,
                                                                  ],
                                                                  attrs: {
                                                                    "data-toggle":
                                                                      "collapse",
                                                                    "data-parent":
                                                                      "#accordion",
                                                                    href:
                                                                      "#collapse_" +
                                                                      service.id,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        service.path
                                                                          ? (_vm.redirect(
                                                                              service.path
                                                                            ),
                                                                            _vm.emitEvent())
                                                                          : null
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("a", [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "content",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            service.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "content flt-rht mr-rt-15 mr-lt-0 pd-tp-2",
                                                                        class: {
                                                                          "mt-8":
                                                                            service.id ===
                                                                            2,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "downCarret",
                                                                            attrs:
                                                                              {
                                                                                src: "/static/images/icons/chevron_up_white.svg",
                                                                                alt: "chevron-up-icon",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "upCarret",
                                                                            attrs:
                                                                              {
                                                                                src: "/static/images/icons/chevron_up_white.svg",
                                                                                alt: "chevron-up-icon",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "panel-collapse collapse",
                                                                  attrs: {
                                                                    id:
                                                                      "collapse_" +
                                                                      service.id,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "panel-body",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "ul",
                                                                        {
                                                                          staticClass:
                                                                            "sub_menu",
                                                                        },
                                                                        _vm._l(
                                                                          service.dropdown,
                                                                          function (
                                                                            link,
                                                                            index
                                                                          ) {
                                                                            return _c(
                                                                              "li",
                                                                              {
                                                                                key: index,
                                                                                staticClass:
                                                                                  "menu_item active-icon",
                                                                                class:
                                                                                  {
                                                                                    active:
                                                                                      _vm.activeMenu.indexOf(
                                                                                        link.shortPath
                                                                                      ) !==
                                                                                      -1,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.redirect(
                                                                                        link.path
                                                                                      )
                                                                                      _vm.emitEvent()
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        href: "javascript:void(0);",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "mr-lt-2-6em wrap-content",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            link.name
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                  [10, 15].includes(_vm.roleId)
                                    ? [
                                        _vm._m(11),
                                        _vm._l(
                                          _vm.premiumServices,
                                          function (service, index) {
                                            return [
                                              service.id === 3
                                                ? _c(
                                                    "li",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "menu_item active-icon",
                                                      class: [
                                                        {
                                                          active:
                                                            _vm.activeMenu.indexOf(
                                                              service.shortPath
                                                            ) !== -1,
                                                        },
                                                        service.icon,
                                                      ],
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: "javascript:void(0);",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.redirect(
                                                                service.path
                                                              )
                                                              _vm.emitEvent()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "content wrap-content",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  service.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                  ![4, 5, 7, 10, 11, 12, 13, 14, 15].includes[
                                    _vm.roleId
                                  ]
                                    ? [
                                        _vm._m(12),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "menu_item active-icon icon-consulting",
                                            on: {
                                              click: function ($event) {
                                                return _vm.redirectfullServices(
                                                  _vm.raQaConsultingURL,
                                                  "RA/QA consulting"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._m(13)]
                                        ),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "menu_item active-icon icon-device-reg",
                                            on: {
                                              click: function ($event) {
                                                return _vm.redirectfullServices(
                                                  _vm.deviceRegistrationURL,
                                                  "Device Registration"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._m(14)]
                                        ),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "menu_item active-icon icon-in-country-rep",
                                            on: {
                                              click: function ($event) {
                                                return _vm.redirectfullServices(
                                                  _vm.inCountryRepURL,
                                                  "In-country representation"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._m(15)]
                                        ),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "last-content menu_item active-icon icon-post-market",
                                            on: {
                                              click: function ($event) {
                                                return _vm.redirectfullServices(
                                                  _vm.postMarketSurveillanceURL,
                                                  "Post-market surveillance"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._m(16)]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          [5, 7, 11].includes(_vm.roleId)
                            ? _c("ul", { staticClass: "menu" }, [
                                _vm._m(17),
                                [5, 11].includes(_vm.roleId)
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "menu_item active-icon icon-launchpad",
                                        class: {
                                          active:
                                            _vm.activeMenu.indexOf(
                                              "layout/launchpad"
                                            ) !== -1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.redirect("/layout/launchpad")
                                            _vm.emitEvent()
                                          },
                                        },
                                      },
                                      [_vm._m(18)]
                                    )
                                  : _vm._e(),
                                [5, 7].includes(_vm.roleId)
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "menu_item active-icon icon-regulatory-alerts",
                                        class: {
                                          active:
                                            _vm.activeMenu.indexOf(
                                              "regulatoryUpdatesAdmin"
                                            ) !== -1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.redirect(
                                              "/layout/regulatoryUpdatesAdmin"
                                            )
                                            _vm.emitEvent()
                                          },
                                        },
                                      },
                                      [_vm._m(19)]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      ![4, 7, 10, 12, 13, 14, 15].includes(_vm.roleId)
        ? _c("template-popup", { attrs: { displayRep: _vm.displayRep } })
        : _vm._e(),
      _c("user-consent-popup", {
        attrs: {
          optInType: _vm.optInType,
          showUserConsentNeverBtn: _vm.showUserConsentNeverBtn,
        },
      }),
      _vm.consentType && _vm.consentType.id
        ? _c("china-user-consent-popup", {
            attrs: { consentType: _vm.consentType },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "content" }, [_vm._v("Marketplace")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "content" }, [_vm._v("Smart Docs")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("span", { staticClass: "content" }, [_vm._v("Resources")]),
      _c("span", { staticClass: "content flt-rht mr-rt-15" }, [
        _c("img", {
          staticClass: "downCarret",
          attrs: {
            src: "/static/images/icons/chevron_up_white.svg",
            alt: "chevron-up-icon",
          },
        }),
        _c("img", {
          staticClass: "upCarret",
          attrs: {
            src: "/static/images/icons/chevron_up_white.svg",
            alt: "chevron-up-icon",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "mr-lt-2-6em wrap-content" }, [
        _vm._v("Regulations & Guidances"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "mr-lt-2-6em wrap-content" }, [
        _vm._v("Tools"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      {
        staticClass: "main-content menu_item active-icon icon-rep-resource",
        attrs: {
          "data-toggle": "collapse",
          "data-parent": "#accordion",
          href: "#collapseRepResources",
        },
      },
      [
        _c("a", [
          _c("span", { staticClass: "content" }, [
            _vm._v("Representation Resources"),
          ]),
          _c("span", { staticClass: "content flt-rht mr-rt-15" }, [
            _c("img", {
              staticClass: "downCarret",
              attrs: { src: "/static/images/icons/chevron_up_white.svg" },
            }),
            _c("img", {
              staticClass: "upCarret",
              attrs: { src: "/static/images/icons/chevron_up_white.svg" },
            }),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "mr-lt-2-6em wrap-content" }, [
        _vm._v("Product Tracker"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "mr-lt-2-6em wrap-content" }, [
        _vm._v("Guides and Templates"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "mr-lt-2-6em wrap-content" }, [
        _vm._v("Agreements"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "content" }, [_vm._v("Smart Exchange")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("h5", { staticClass: "main-content-service" }, [
        _vm._v("Premium Services"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("h5", { staticClass: "main-content-service" }, [
        _vm._v("Premium Services"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("h5", { staticClass: "main-content-service" }, [
        _vm._v("Full Services"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("span", { staticClass: "content wrap-content" }, [
        _vm._v("RA/QA consulting"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("span", { staticClass: "content wrap-content" }, [
        _vm._v("Device Registration"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("span", { staticClass: "content wrap-content" }, [
        _vm._v("In-country representation"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("span", { staticClass: "content wrap-content" }, [
        _vm._v("Post-market surveillance"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("h5", { staticClass: "main-content-service" }, [_vm._v("Admin")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "content" }, [_vm._v("Launchpad")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "javascript:void(0);" } }, [
      _c("span", { staticClass: "content wrap-content" }, [
        _vm._v("Regulatory Watch Admin"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }